export default {
    imageDashboardSummary: {
        totalImagesGenerated: 'Totalt antall genererte bilder',
        cost: 'Kostnad',
        imagesPerDay: 'Bilder/dag',
    },
};
